import i18n from '../../../../../../../i18n';

export const annexOptions = [
  { value: 'GARDEN_SHED', label: i18n.t('GARDEN_SHED') },
  { value: 'CARPORT', label: i18n.t('CARPORT') },
  { value: 'GAZEBO', label: i18n.t('GAZEBO') },
  { value: 'OTHER', label: i18n.t('OTHER') },
];
